import {Component, OnInit} from '@angular/core';
import {filter, mergeMap, tap} from 'rxjs/operators';
import {ActivatedRoute} from '@angular/router';
import {BrokerMessagesService} from '../../service/broker-messages.service';

@Component({
  selector: 'app-messages-details',
  templateUrl: './messages-details.component.html',
  styleUrls: ['./messages-details.component.scss']
})
export class MessagesDetailsComponent implements OnInit {

  messageJson = {};
  isInit: boolean;
  isFromPosf: boolean;
  isSuccess: boolean;
  resultMessage: string;

  constructor(
    private route: ActivatedRoute,
    private brokerMessagesService: BrokerMessagesService
  ) { }

  ngOnInit(): void {
    this.accordionLogic();

    this.route.queryParams
      .pipe(
        filter(params => params.messageId),
        tap(params => {
          this.isInit = params.isInit;
          this.isFromPosf = params.isFromPosf;
          this.isSuccess = params.isSuccess;
          this.resultMessage = params.result;
        }),
        mergeMap(params => this.brokerMessagesService.getMessageDetails(params.messageId))
      ).subscribe(res => {
        console.log(res);
        this.messageJson = JSON.parse(res.toString());
    });
    /*
    this.addressService.getCounty(this.place.county).pipe(
      mergeMap((county: CountyDTO) => this.comparatorService.getElectricityOfferByCode(this.offerCode, county.name)))
      .subscribe((electricComparatorResult: ElectricComparatorResult[]) => {
      */
  }

  private accordionLogic() {
    let acc = document.getElementsByClassName('accordion');
    let i;

    for (i = 0; i < acc.length; i++) {
      acc[i].addEventListener('click', function() {
        /* Toggle between adding and removing the "active" class,
        to highlight the button that controls the panel */
        this.classList.toggle('active');

        /* Toggle between hiding and showing the active panel */
        let panel = this.nextElementSibling;
        if (panel.style.display === 'block') {
          panel.style.display = 'none';
        } else {
          panel.style.display = 'block';
        }
      });
    }
  }

  back() {
    history.back();
  }
}
